import { Container } from '@mui/material';

import MarkdownPage from '../components/MarkdownPage';

const PHATtesMiteinanderPage = (): JSX.Element => (
  <Container maxWidth="md" style={{ backgroundColor: '#fff' }}>
    <MarkdownPage name="ueber-uns" />
  </Container>
);

export default PHATtesMiteinanderPage;
